export const MESSAGE_STATUS = {
  inProgress: 'in_progress',
  completed: 'completed',
  failed: 'failed'
}

export const WELCOME_MESSAGE = 'Did you know that $17 billion will be invested into Walt Disney World over the next 5 years?'
